<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import * as globalEnum from "src/common/global-enum";
import { setInfo1, setInfo2, copySetInfo2, setInfo8 } from "./config";
import { setInfo7, setArray } from "./../artificial/config";
import { parseImgUrlToken } from "src/filter/modules/img";
import printHead from "./../layout/print-head.vue";
const textAlign = "right";
const labelWidth = 90;
@Component({
  name: "normal-print",
  components: { printHead }
})
export default class App extends Vue {
  info = {
    table1: {},
    table2: {},
    table3: {},
    table4: {}
  };
  defailInfo = {};
  list = [];
  ACCESSORY_QUOTED_ITEM_NORMAL_PRINT() {
    let ids = this.$route.query.ids
    ids = ids.split(',')
    return new Promise((resolve, reject) => {
      this.$apis.autoAPi
        .ACCESSORY_QUOTED_ITEM_NORMAL_PRINT({
          ids,
          "pageNumber": 1,
          "pageSize": 999
        })
        .done(res => {
          resolve(res);
        })
        .fail(err => {
          reject();
        });
    });
  }
  mounted() {
    this.ACCESSORY_QUOTED_ITEM_NORMAL_PRINT()
      .then(res => {
        if(res.data && res.data.records.length) {
          this.defailInfo = res.data.records[0];
          this.defailInfo.printDate = this.$utils.formatTime(new Date, '{y}/{m}/{d} {h}:{i}:{s}')
          let spliceArray = [];
          const remarksOverLength = [] // 需要调整的高度的项
          let count = 0
          res.data.records.forEach((item, $index) => {
            item.infoRemark = item.infoRemark ? item.infoRemark : ''
            const i = parseInt(count / 4); //显示具体的数据  当前项字数多久默认占一行
             if(item.infoRemark.length>66){ //178
                remarksOverLength.push([item])
               count--
               return
               // return spliceArray[spliceArray.length]=
             }
            if (!spliceArray[i]) spliceArray[i] = [];
            spliceArray[i].push(item);
            count++
          });
          spliceArray = [...spliceArray,...remarksOverLength]
          let maxNum = 5
          this.list = spliceArray.map(item => {
            const setInfo2Info = setInfo2.call(this, this.defailInfo);
            let strLength = item[0].infoRemark.length
            maxNum = strLength >66 ? 2 :  maxNum
            setInfo2Info.children = setArray(
              setInfo2Info.children.concat(item.map(setItemList)), // 4 显示行数4-1
              maxNum,
              copySetInfo2
            );
            return {
              table1: setInfo1.call(this, this.defailInfo),
              table2: setInfo2Info,
              table3: setInfoTableHead5.call(this, this.defailInfo),
              table4: setInfo8.call(this, this.defailInfo)
            };
          });
          console.log(this.list);
        }
      })
      .catch(err => {});

    function setItemList(item) {
      return {
        style: {
          // height: "26mm",
          height: item.infoRemark.length>66 ? '102mm':'26mm',
          flex: "none"
        },
        children: [
          {
            style: {
              width: "30mm",
              flex: "none"
            },
            width: null,
            text: "",
            render: (h, value) => {
              return (
                <img
                  src={item.imgUrl}
                  style="width: 26mm;height: 26mm"
                />
              );
            }
          },
          {
            width: null,
            text: item.vendorMaterialDesc,
            style: {
              width: "30mm",
              flex: "none",
            }
          },
          {
            width: null,
            text: item.vendorMaterialCode
          },
          {
            width: null,
            text: item.stanard
          },
          {
            width: null,
            text: item.yarnStanard
          },
          {
            width: null,
            text: item.composition
          },
          {
            width: null,
            text: item.colorDesc
          },
          {
            width: null,
            text: item.baseUnit
          },
          {
            width: null,
            text: item.minOrderQty
          },
          {
            width: null,
            style: { flex: "none", width: "20%" },
            children: [
              {
                width: null,
                text: item.price1
              },
              {
                width: null,
                text: item.price2
              },
              {
                width: null,
                text: item.price3
              },
              {
                width: null,
                text: item.price4
              }
            ]
          },
          {
            width: null,
            text: item.sampleDeliveryDate
          },
          {
            width: null,
            text: item.wearDeliveryDate
          },
          {
            style: {
              width: "40mm",
              flex: "none"
            },
            width: null,
            text: item.infoRemark
          }
        ]
      };
    }
    function setInfoTableHead5(item) {
      return {
        style: {
          flexDirection: "row"
        },
        children: [
          setInfo7.call(this, item)
          // {
          //   width: null,
          //   text: `备注:${item.infoRemark}`
          // }
        ]
      };
    }
  }
  render(h) {
    return (
      <div class="excipient-print">
        {this.list.map(item => {
          return (
            <div class="excipient-print__item">
              <print-head title={this.defailInfo.companyName} class="print-head"></print-head>
              <multiline-print
                {...{
                  props: {
                    info: item.table1
                  }
                }}
              ></multiline-print>
              <multiline-print
                {...{
                  props: {
                    info: item.table2
                  }
                }}
              ></multiline-print>
              <multiline-print
                {...{
                  props: {
                    info: item.table3
                  }
                }}
              ></multiline-print>
              <multiline-print
                {...{
                  props: {
                    info: item.table4
                  }
                }}
              ></multiline-print>
            </div>
          );
        })}
      </div>
    );
  }
}
</script>


<style lang="scss" scoped>
@media print {
  .excipient-print__item {
    page-break-inside: avoid !important;
    page-break-before: unset !important;
    font-size: 12px;
  }
}
.excipient-print__item {
  margin-bottom: 6mm;
  page-break-inside: avoid !important;
    page-break-before: unset !important;
}
.print-head {
  margin: 6mm;
}
</style>